import API_ROUTES from "../constants/api";
import { DEFAULT_ITEMS_PER_PAGE } from "../constants/common";
import HttpUtil from "../http-handler/http-util";

export default class SupplyMaterialService {
  static getMaterialList(pageNumber = 0, pageSize = DEFAULT_ITEMS_PER_PAGE, key='', sort='', companyId,activeOnly) {
    return HttpUtil.get(API_ROUTES.SUPPLYMATERIAL.LIST.replace("<pageNumber>", pageNumber)
    .replace("<pageSize>", pageSize)
    .replace("<key>", key)
    .replace("<sort>", sort)
    .replace("<companyId>", companyId)
    .replace("<activeOnly>", activeOnly));
  }

  static onSubmit(cId,params) {
    var url = '';
    if(params.id!=null || params.id!==undefined) {
        url = API_ROUTES.SUPPLYMATERIAL.SUBMIT.replace("<companyId>", cId)
        .replace("<id>", params.id);
        return HttpUtil.put(url,params);
    } else {
        url = API_ROUTES.SUPPLYMATERIAL.SUBMIT.replace("<companyId>", cId).replace("<id>", '');
        return HttpUtil.post(url,params);
    }
   
  }
 
}